module.exports = __webpack_public_path__ + "static/img/F02-合肥新华公学.6d3cf97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/F02-合肥新华公学.png
// module id = WQjQ
// module chunks = 0